'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicKeyToggle = exports.browserName = exports.isVideoMime = exports.isImageMime = exports.isInclusivelyBeforeDay = exports.isInclusivelyAfterDay = exports.isAfterDay = exports.isBeforeDay = exports.isSameDay = exports.getImage = exports.getCardType = exports.getCardImage = exports.normalizePhoneNum = exports.formatPhoneNumber = exports.containsDotSymbol = exports.containsAtSymbol = exports.containsString = exports.formatNumber = exports.isNumber = exports.getCleanFormatter = exports.getFormatter = exports.stripPhoneFormatting = exports.stripFormatting = exports.getIsTextPhoneNumberFormat = undefined;
exports.resourceUrl = resourceUrl;
exports.isChrome = isChrome;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _bowser = require('bowser');

var _bowser2 = _interopRequireDefault(_bowser);

var _amex = require('@zipwhip/zipkit-icons/icons/amex.png');

var _amex2 = _interopRequireDefault(_amex);

var _visa = require('@zipwhip/zipkit-icons/icons/visa.png');

var _visa2 = _interopRequireDefault(_visa);

var _discover = require('@zipwhip/zipkit-icons/icons/discover.png');

var _discover2 = _interopRequireDefault(_discover);

var _mastercard = require('@zipwhip/zipkit-icons/icons/mastercard.png');

var _mastercard2 = _interopRequireDefault(_mastercard);

var _libphonenumberJs = require('libphonenumber-js');

var _getCleanPhoneNumber = require('../utils/get-clean-phone-number');

var _getCleanPhoneNumber2 = _interopRequireDefault(_getCleanPhoneNumber);

var _userDefault = require('@zipwhip/zipkit-icons/icons/user-default.png');

var _userDefault2 = _interopRequireDefault(_userDefault);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var formatter = void 0;

var getIsTextPhoneNumberFormat = exports.getIsTextPhoneNumberFormat = function getIsTextPhoneNumberFormat() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isTextPhoneNumberFormat = false;
  var regex = /\(\d\d\d\).*-/g;
  var matchList = text.match(regex);

  if (!!matchList && matchList.length > 0) {
    isTextPhoneNumberFormat = true;
  }

  return isTextPhoneNumberFormat;
}; // full regex explanation https://regex101.com/r/llBUAq/1/


var stripFormatting = exports.stripFormatting = function stripFormatting() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return text ? text.replace(/\s|(?!.*@)[-()]/g, '') : '';
};

var stripPhoneFormatting = exports.stripPhoneFormatting = function stripPhoneFormatting() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return text ? text.replace(/\s|(?!.*@)[-()\.]/g, '') : '';
};

var getFormatter = exports.getFormatter = function getFormatter() {
  return formatter = formatter || new _libphonenumberJs.AsYouType('US');
};

var getCleanFormatter = exports.getCleanFormatter = function getCleanFormatter() {
  getFormatter().reset();
  return formatter;
};

var isNumber = exports.isNumber = function isNumber(number) {
  return !isNaN(parseInt(number, 10));
};

var formatNumber = exports.formatNumber = function formatNumber(number) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCleanFormatter();
  return number.split('').reduce(function (result, digit) {
    return format.input(digit);
  }, null);
};

var containsString = exports.containsString = function containsString(text, find) {
  return text ? text.indexOf(find) > -1 : false;
};

var containsAtSymbol = exports.containsAtSymbol = function containsAtSymbol(text) {
  return containsString(text, '@');
};

var containsDotSymbol = exports.containsDotSymbol = function containsDotSymbol(text) {
  return containsString(text, '.');
};

function resourceUrl(url) {
  var _window = window,
      zwResourceUrl = _window.zwResourceUrl;
  return zwResourceUrl ? zwResourceUrl(url) : url;
}
/**
 * return formated phone number
 * @param  {string} phoneNumber a valid phone number
 * @return {string}             a phone number in (xxx) xxx-xxxx format
 */


var formatPhoneNumber = exports.formatPhoneNumber = function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return null;
  }

  var cleanPhoneNum = (0, _getCleanPhoneNumber2.default)(phoneNumber);
  return '(' + cleanPhoneNum.slice(0, 3) + ') ' + cleanPhoneNum.slice(3, 6) + '-' + cleanPhoneNum.slice(6, 10);
};

var normalizePhoneNum = exports.normalizePhoneNum = function normalizePhoneNum(value, previousValue) {
  if (!value) {
    return value;
  }

  var phoneNumber = value.replace(/[^\d]/g, '');

  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (phoneNumber.length === 3) {
      return '(' + phoneNumber + ') ';
    }

    if (phoneNumber.length === 6) {
      return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3) + '-';
    }
  }

  if (phoneNumber.length <= 3) {
    return phoneNumber;
  }

  if (phoneNumber.length <= 6) {
    return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3);
  }

  return formatPhoneNumber(phoneNumber);
};

var getCardImage = exports.getCardImage = function getCardImage(cardType) {
  switch (cardType.toLowerCase()) {
    case 'visa':
      {
        return _visa2.default;
      }

    case 'mastercard':
      {
        return _mastercard2.default;
      }

    case 'amex':
      {
        return _amex2.default;
      }

    case 'american express':
      {
        return _amex2.default;
      }

    case 'discover':
      {
        return _discover2.default;
      }

    default:
      {
        return '';
      }
  }
};

var getCardType = exports.getCardType = function getCardType(number) {
  if (!number) {
    return '';
  } // visa


  var re = new RegExp('^4');

  if (number.match(re) != null) {
    return 'Visa';
  } // Mastercard


  re = new RegExp('^5[1-5]');

  if (number.match(re) != null) {
    return 'Mastercard';
  } // AMEX


  re = new RegExp('^3[47]');

  if (number.match(re) != null) {
    return 'AMEX';
  } // Discover


  re = new RegExp('^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)');

  if (number.match(re) != null) {
    return 'Discover';
  }

  return '';
};

var getImage = exports.getImage = function getImage(number) {
  if (number) {
    return 'https://landline.zipwhip.com/face/' + number + '/image/?thumbnail=true&embedded=true&size=43';
  }

  return _userDefault2.default;
};
/**
 * Some date helper functions, copied from react-dates, they look useful
 */


var isSameDay = exports.isSameDay = function isSameDay(a, b) {
  if (!_moment2.default.isMoment(a) || !_moment2.default.isMoment(b)) return false; // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow

  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
};

var isBeforeDay = exports.isBeforeDay = function isBeforeDay(a, b) {
  if (!_moment2.default.isMoment(a) || !_moment2.default.isMoment(b)) return false;
  var aYear = a.year();
  var aMonth = a.month();
  var bYear = b.year();
  var bMonth = b.month();
  var isSameYear = aYear === bYear;
  var isSameMonth = aMonth === bMonth;
  if (isSameYear && isSameMonth) return a.date() < b.date();
  if (isSameYear) return aMonth < bMonth;
  return aYear < bYear;
};

var isAfterDay = exports.isAfterDay = function isAfterDay(a, b) {
  if (!_moment2.default.isMoment(a) || !_moment2.default.isMoment(b)) return false;
  return !isBeforeDay(a, b) && !isSameDay(a, b);
};

var isInclusivelyAfterDay = exports.isInclusivelyAfterDay = function isInclusivelyAfterDay(a, b) {
  if (!_moment2.default.isMoment(a) || !_moment2.default.isMoment(b)) return false;
  return !isBeforeDay(a, b);
};

var isInclusivelyBeforeDay = exports.isInclusivelyBeforeDay = function isInclusivelyBeforeDay(a, b) {
  if (!_moment2.default.isMoment(a) || !_moment2.default.isMoment(b)) return false;
  return !isAfterDay(a, b);
};

var isImageMime = exports.isImageMime = function isImageMime(item) {
  return /image\/*/.test(item);
};

var isVideoMime = exports.isVideoMime = function isVideoMime(item) {
  return /video\/*/.test(item);
};

var browserName = exports.browserName = function browserName() {
  return global.window && global.window.navigator && _bowser2.default.getParser(global.window.navigator.userAgent).getBrowserName();
};

var basicKeyToggle = exports.basicKeyToggle = function basicKeyToggle(e, successFunction) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault(); //prevents actions like scrolling a window with spacebar when activating

    successFunction && successFunction(e);
  }
};

function isChrome() {
  var userAgent = !!navigator && navigator.userAgent;
  userAgent = !!userAgent && userAgent.toLowerCase();
  return userAgent.indexOf('chrome') > -1;
}